const MONTHS = ' January February March April May June July August September October November December'.split(' ');
export function humanizeYearAndMonth(yearAndMonth) {
  const [,year, month] = yearAndMonth ? yearAndMonth.match(/(\d\d\d\d)(?:-(\d\d)|)/) : [];
  const monthName = month && MONTHS[Number(month)];
  return [monthName, year].filter(s => !!s).join(' ');
}
